import styled from 'styled-components';
import { Image } from 'antd';

export const ImageWrapper = styled(Image)`
  object-fit: cover;
`;
